import * as React from 'react';
import { PiralDocsLogoComponentProps } from '../scripts/types';

const Logo: React.FC<PiralDocsLogoComponentProps> = ({ children }) => <>{children}</>;

export default Logo;
